import { AccAnchor } from "@components/base/AccAnchor";
import cn from "classnames";
import React from "react";

const DEFAULT_HUBSPOT_BOOKING_URL =
  "https://calendly.com/accuranker-sales/accuranker-introduction-clone";

type HubSpotBookingLinkProps = {
  buttonText: string;
  analyticsId: string;
  armaValue?: string;
  padding?: string;
  hubSpotBookingUrl?: string;
  onClick?: () => void;
  className?: string;
};

export const HubSpotBookingLink = ({
  buttonText,
  hubSpotBookingUrl,
  analyticsId,
  armaValue,
  onClick,
  padding = "standard",
  className,
}: HubSpotBookingLinkProps) => (
  <AccAnchor
    role="button"
    className={cn(
      "flex items-center justify-center rounded-md bg-accuRankerOrange-500 text-center font-medium text-white transition-colors duration-300 hover:bg-accuRankerOrange-900 hover:text-white",
      className,
      {
        "min-h-[48px] px-12 py-2": padding === "large",
        "min-h-[48px] px-4 py-2": padding === "standard",
        "px-4 py-2": padding === "medium",
        "min-h-[38px] px-1 py-1": padding === "small",
      }
    )}
    id={analyticsId}
    armaTag={analyticsId}
    armaValue={armaValue}
    onClick={onClick}
    href={hubSpotBookingUrl || DEFAULT_HUBSPOT_BOOKING_URL}
    target="_blank"
  >
    <span className="block max-w-full truncate">{buttonText}</span>
  </AccAnchor>
);
